import React from "react";
import classNames from "classnames";

import "./styles.styl";

export default function InputTextarea(props) {
  let {
    className,
    value,
    placeholder,
    label,
    focus,
    errors,
    onChange,
    disabled,
    readOnly,
    onBlur,
    onFocus,
    ...rest
  } = props;

  if (!onChange) {
    rest = { ...rest, defaultValue: value || "" };
  } else {
    rest = { ...rest, value: value || "" };
  }

  return (
    <textarea
      className={classNames(
        "input-textarea",
        {
          "has-focus": focus,
          "has-errors": errors,
          "is-disabled": disabled,
          "is-readonly": readOnly,
        },
        className,
      )}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
      readOnly={readOnly}
      placeholder={placeholder || label}
      {...rest}
    />
  );
}
